import { buildBreadcrumbs } from 'helpers/breadcrumbs';
import { Product } from 'models/product';
import { getProductFilteredCategories } from 'shared/helpers/product';

export const getBreadcrumbs = ({
  localized,
  product,
  userFacingDepartment,
}: {
  localized: (url: string) => string;
  product: Product;
  userFacingDepartment: string;
}) => {
  const categoryPath = getProductFilteredCategories(product, userFacingDepartment);
  const breadcrumbCategory = categoryPath[0];
  const breadcrumbList = buildBreadcrumbs(
    breadcrumbCategory.id,
    categoryPath,
    userFacingDepartment,
    localized,
    product,
  );
  return { breadcrumbList };
};
